module.exports = __webpack_public_path__ + "static/media/ETMALC2.7c605730.png";